'use client';

import type { ReactElement } from 'react';
import { GoogleIcon } from '@/shared/components/primitives/svg/google-icon';
import { AccountProvider } from '@ecom/storefront-auth-db';
import { signInWithGoogle } from '@/features/auth/internal/actions/social-auth-actions';
import { SocialAuthButton } from '@/features/auth/shared/components/social-auth-button';
import { cn } from '@/shared/utils/cn';

type GoogleLinkProps = {
  buttonText: string;
  intent: 'login' | 'signup';
  callbackUrl?: string;
  className?: string;
  buttonClassName?: string;
  onStart?: () => void;
  subscribeToNewsletter?: boolean;
};

export const GoogleLink = ({
  buttonText,
  intent,
  callbackUrl,
  className,
  buttonClassName,
  onStart,
  subscribeToNewsletter,
}: GoogleLinkProps): ReactElement => {
  return (
    <SocialAuthButton
      buttonText={buttonText}
      intent={intent}
      provider={AccountProvider.GOOGLE}
      icon={<GoogleIcon />}
      callbackUrl={callbackUrl}
      className={className}
      buttonClassName={cn(
        'h-full w-full min-w-64 bg-gray-200 text-neutral-900 hover:bg-gray-50 hover:!text-neutral-900 disabled:cursor-not-allowed disabled:opacity-70 lg:hover:!text-neutral-900',
        buttonClassName,
      )}
      onStart={onStart}
      onWebSignIn={signInWithGoogle}
      subscribeToNewsletter={subscribeToNewsletter}
    />
  );
};
